import React, { Component } from 'react';
import RequestShapefiles from '../components/RequestShapefiles';
import RequestProfiles from '../components/RequestProfiles';
import ContactForm from '../components/ContactForm';
import RequestPreview from '../components/RequestPreview';
import Cart from '../components/Cart';
import { withRouter } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../scss/Download.scss';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ReviewWelcome from '../components/ReviewWelcome';
import RequestSelections from '../components/RequestSelections';
import RequestCompleted from '../components/RequestCompleted';
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'


// import appSettings from '../assets/app-settings.json';

const WELCOME_PAGE = 'WELCOME_PAGE';
const CONTACT_PAGE = 'CONTACT_PAGE';
const SELECTIONS_PAGE = 'SELECTIONS_PAGE';
const PREVIEW_PAGE = 'PREVIEW_PAGE';
const SUBMITTED_PAGE = 'SUBMITTED_PAGE';
export class RequestPage extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        activeTab: "shapefiles",
        currentPage: WELCOME_PAGE,
        hasValidContactInfo: false,
        submit: false,
        isBusy: false,
        isShowModal: false,
        isShowToast: false,
        toastTitle: "",
        toastMessage: "",
        requestPayload: null
    };

    static PAGES = [WELCOME_PAGE, CONTACT_PAGE, SELECTIONS_PAGE, PREVIEW_PAGE, SUBMITTED_PAGE];

    previousPage = () => {
        const pageIndex = RequestPage.PAGES.findIndex(p => p === this.state.currentPage);
        if (pageIndex === 0) {
            return;
        }

        this.setState({
            currentPage: RequestPage.PAGES[pageIndex - 1]
        }, () => {
            // console.log("[currentPage]", this.state.currentPage);
        });
    }

    nextPage = () => {
        const pageIndex = RequestPage.PAGES.findIndex(p => p === this.state.currentPage);
        if (pageIndex === RequestPage.PAGES.length - 1) {
            return;
        }

        this.setState({
            currentPage: RequestPage.PAGES[pageIndex + 1],
            submit: false
        }, () => {
            // console.log("[currentPage]", this.state.currentPage);
        });
    }

    canGoToPreviousPage = () => {
        const pageIndex = RequestPage.PAGES.findIndex(p => p === this.state.currentPage);
        return pageIndex !== 0 && pageIndex !== 4;
    }

    canGoToNextPage = () => {
        const pageIndex = RequestPage.PAGES.findIndex(p => p === this.state.currentPage);

        if (pageIndex === 0) {
            return false;
        }

        // special condition
        if (pageIndex === 1 && !this.state.hasValidContactInfo) {
            return false;
        }

        return pageIndex !== RequestPage.PAGES.length - 1;
    }

    canShowGoToNextPage = () => {
        return this.state.currentPage !== WELCOME_PAGE && this.state.currentPage !== SUBMITTED_PAGE
    }

    canSubmitRequest = () => {
        const canSubmit = this.state.currentPage === PREVIEW_PAGE && this.state.requestPayload !== null;
        return canSubmit;
    }

    isSubmitRequestEnabled = () => {
        console.log("[this.state.requestPayload]", this.state.requestPayload);
        if (this.state.requestPayload !== null) {
            const geoDatasetPreview = JSON.parse(this.state.requestPayload.geoDatasetPreview);
            const profileDatasetPreview = JSON.parse(this.state.requestPayload.profileDatasetPreview);

            let numProfileSurveys = 0;
            if (profileDatasetPreview.length === 1) {
                numProfileSurveys = profileDatasetPreview[0].surveys.length;
            } else if (profileDatasetPreview.length > 1) {
                numProfileSurveys = profileDatasetPreview.map(d => d.surveys).reduce((a, b) => {
                    return a.length + b.length;
                });
            }

            if (geoDatasetPreview.length > 0 || numProfileSurveys > 0) {
                return true;
            }
        }
        return false;
    }

    verifySubmitRequest = () => {
        this.setModalShow(true);
    }

    submitRequest = () => {

        if (!this.state.requestPayload) {
            return;
        }

        this.setModalShow(false);
        this.updateBusyState(true);

        setTimeout(() => {
            const appSettings = window.AppConfigSettings;
            const url = appSettings.baseApiUrl + "/downloads/requests/submit";
            axios.post(url, this.state.requestPayload)
                .then((res) => {
                    if (res.status !== 200) {
                        console.log(res);
                    }
                    this.nextPage();
                    this.resetAfterSubmit();
                })
                .catch((error) => {
                    console.log(error);
                    this.showError({
                        title: "Error submitting request",
                        message: "An error occured while submitting request. Please try again after a few minutes."
                    });
                })
                .finally(() => {
                    this.updateBusyState(false);
                });
        }, 2000);

        // TODO: clean up localStorage after successful submission
    }

    resetAfterSubmit = () => {
        // localStorage.removeItem("contactInfo");       
        localStorage.removeItem("profileDatasetsSelected");
        localStorage.removeItem("geoDatasetsSelected");
        localStorage.removeItem("profileSelectedSite");
        localStorage.removeItem("geoSelectedSite");
        localStorage.removeItem("ActiveRequestTab");
    }

    handleStartNewRequest = () => {
        this.setState({
            currentPage: RequestPage.PAGES[0]
        }, () => {
        });
    }

    updateBusyState = (isBusy) => {
        this.setState({
            isBusy: isBusy
        });
    }

    handleContactInfoValidated = (isValid) => {
        this.setState({
            hasValidContactInfo: isValid
        });
    }

    handleSelectData = (activeTab) => {
        localStorage.setItem("ActiveRequestTab", activeTab);

        if (this.state.currentPage === WELCOME_PAGE) {
            this.nextPage();
        }
    }

    handlePayloadReady = (payload) => {
        this.setState({
            requestPayload: payload
        });
    }

    setModalShow = (isShow) => {
        if (!isShow) {
            isShow = false;
        }
        this.setState({
            isShowModal: isShow
        });
    }
    handleCloseToast = (event) => {
        this.setState({
            isShowToast: false
        });
    }

    showError = (error) => {
        this.setState({
            toastTitle: error.title,
            toastMessage: error.message,
            isShowToast: true
        });
    }

    getContinueButtonLabel = () => {
        if (this.state.currentPage === CONTACT_PAGE) {
            return "Select Data";
        }

        if (this.state.currentPage === SELECTIONS_PAGE) {
            return "Review Selection";
        }

        return "Continue";
    }

    render() {
        return (
            <div className="request-page">
                {/* <div>Browser location: {this.props.location.pathname}</div> */}

                {/* <aside className="aside aside-1"></aside> */}

                {/* <div className="main"> */}
                <div className="request-page-header">
                    <h3>CHRGIS Data Request</h3>
                </div>
                {this.state.isBusy ?
                    <div className="request-busy-indicator">
                        <Spinner
                            as="div"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                        />
                        Working...
                    </div>
                    : null
                }
                <div className="request-page-container">
                    {
                        this.state.currentPage === WELCOME_PAGE ?
                            <ReviewWelcome
                                onSelectData={this.handleSelectData}
                            ></ReviewWelcome>
                            :
                            <></>
                    }
                    {
                        this.state.currentPage === CONTACT_PAGE ?
                            <ContactForm
                                onValidate={this.handleContactInfoValidated}
                            ></ContactForm>
                            :
                            <></>
                    }
                    {
                        this.state.currentPage === SELECTIONS_PAGE ?
                            <RequestSelections
                                onIsBusyChange={this.updateBusyState}
                            ></RequestSelections>
                            :
                            <></>
                    }
                    {
                        this.state.currentPage === PREVIEW_PAGE ?
                            <RequestPreview
                                onIsBusyChange={this.updateBusyState}
                                onPayloadReady={this.handlePayloadReady}
                            ></RequestPreview>
                            :
                            <></>
                    }
                    {
                        this.state.currentPage === SUBMITTED_PAGE ?
                            <RequestCompleted
                                onStartNewRequest={this.handleStartNewRequest}
                            ></RequestCompleted>
                            :
                            <></>
                    }

                </div>
                <div className="request-page-footer">
                    {this.canGoToPreviousPage() ?
                        <button
                            onClick={this.previousPage}
                        ><i className="fas fa-angle-double-left"></i>Previous
                        </button>
                        :
                        <span></span>
                    }

                    {this.canShowGoToNextPage() && !this.canSubmitRequest() ?
                        <button
                            disabled={!this.canGoToNextPage()}
                            onClick={this.nextPage}
                        ><i className="fas fa-angle-double-right"></i>{this.getContinueButtonLabel()}
                        </button>
                        :
                        <></>
                    }

                    {this.canSubmitRequest() ?
                        <button
                            disabled={!this.isSubmitRequestEnabled()}
                            onClick={this.verifySubmitRequest}
                        ><i className="fas fa-paper-plane"></i>Submit Request
                        </button>
                        :
                        <></>
                    }
                </div>
                {/* </div> */}

                {/* <aside className="aside aside-2"></aside> */}

                <ToastContainer className="p-3" position='top-center'>
                    <Toast show={this.state.isShowToast} delay={5000} autohide bg="danger" onClose={this.handleCloseToast}>
                        <Toast.Header>
                            <strong className="me-auto">{this.state.toastTitle}</strong>
                            {/* <small className="text-muted">2 seconds ago</small> */}
                        </Toast.Header>
                        <Toast.Body>
                            {this.state.toastMessage}
                        </Toast.Body>
                    </Toast>
                </ToastContainer>

                <Modal
                    show={this.state.isShowModal}
                    onHide={this.setModalShow}
                    backdrop="static"
                    keyboard={false}
                    centered
                    aria-labelledby="contained-modal-title-vcenter">
                    <Modal.Header closeButton>
                        <Modal.Title>Data Request Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Please confirm that you have carefully reviewed this request and wish to submit now. 
                            You may "Cancel" and go back to select additional files/data sets with this request as needed.</p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button
                            onClick={() => this.setModalShow(false)}
                        ><i className="fas fa-times"></i>Cancel
                        </button>
                        <button className="button-submit"
                            onClick={this.submitRequest}
                        ><i className="fas fa-paper-plane"></i>Submit
                        </button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}

export default withRouter(RequestPage)
